/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import {
  useDisclosure,
  Box,
  VStack,
  HStack,
  Stack,
  Switch,
} from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import _ from 'lodash';
import { Text } from '@mybridge/ui/text';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { useRouter } from 'next/router';
import { useToast } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import {
  EarthGlobeIcon,
  TeamIcon,
  OnlyMeLockIcon,
  BackArrow,
  ArrowRight,
} from '@mybridge/icons';
import { AudienceFriendsModal } from 'v4/snippets/settings/component/audience-modal-friends';
import { AudienceFriendsListModal } from 'v4/snippets/settings/component/audience-modal-friends-list';
import { setAccountPermissions, getUserProfileInfo } from 'v4/store/actions/user-profile.actions';
import { FindPeopleIcon } from '@mybridge/icons/FindPeopleIcon';
import { MentionTag } from '@mybridge/icons/MentionTag';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export default function MentionAndTag({ setSelectedComponent, selectedComponent }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const toast = useToast();
  const { t } = useTranslator();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [modalOpen, setModalOpen] = useState(false);
  const [heading, setHeading] = useState(null);
  const [googleLinked, setGoogleLinked] = useState(false);
  const userFriendsPermDisc = useDisclosure();
  const userFriendsListPermDisc = useDisclosure();

  const renderPermissionSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: 'Everyone',
        };
      case 2:
        return {
          icon: <TeamIcon width="16px" height="16px" color="#5B5B5B" />,
          text: 'myNetwork',
        };
      case 3:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: 'Everyone',
        };
    }
  };

  const renderFriendsListSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: '1st Degree',
        };
      case 2:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: '1st Degree',
        };
    }
  };

  const friendReqOption = _.get(
    userProfileInfo,
    'field_audience_visibility.WHO_CAN_SEND_FRIEND_REQ'
  );
  const friendListOption = _.get(
    userProfileInfo,
    'field_audience_visibility.WHO_CAN_SEE_FRIENDS'
  );
  const mentionAndTagsValue = _.get(
    userProfileInfo,
    'field_audience_visibility.MENTIONS_AND_TAGS'
  );

  const updateTagsMentionsOption = (e) => {
    const payload = {
      attribute: 'MENTIONS_AND_TAGS', // WHO_CAN_SEND_FRIEND_REQ | WHO_CAN_SEE_FRIENDS | MENTIONS_AND_TAGS
      audience: e.target.checked,
    };
    dispatch(setAccountPermissions(payload)).then((res) => {
      if (res?.payload) {
        dispatch(getUserProfileInfo());
      }
    });
  };


  return (
    <AuthenticatedProviders>
  <Box className="user-settings--integration" 
  marginTop ="30px"
  borderRadius ="8px"
  p="16px 16px 20px 10px" 
  border="1px solid #D9D9D9">
            <VStack alignItems gap="12px">
              <HStack font="Inter"  justifyContent="space-between">
                <Text color="#868585"
                fontSize="16px"
                fontWeight = "500"
                lineHeight ="19.2px"
                >{t('settingsAudience.mentionsOrTags') || "Mentions or Tags"}</Text>
                <Switch
                isChecked={mentionAndTagsValue}
                onChange={(e) => updateTagsMentionsOption(e)}
              />
          
              </HStack>

              {/* <Button
                type="button"
                // onClick={() => {audienceDisc.onOpen(); setPermissionValue('profile_intro')}}
                leftIcon={renderPermissionSwitch(introValue)?.icon}
              >
                {renderPermissionSwitch(introValue)?.text}
              </Button> */}
                <Text fontSize="12px" color="#747474">
                  {t('settingsAudience.mentionsExample') || "Example of mentions include tagging you in posts or photos. You can control the visibility of your existing mentions."}
                </Text>
            </VStack>
        </Box>
    </AuthenticatedProviders>
  );
}
